oyc.JobDetails = {
  selectors: {
    title: '.page-title',
    actionBar: '.action-bar',
    actionBarTitle: '.job-title',
    header: '#site-header',
  },
  title: null,
  actionBar: null,
  actionBarTitle: null,
  header: null,
  init: function () {
    this.actionBar = document.querySelector(this.selectors.actionBar);
    if (this.actionBar) {
      this.title = document.querySelector(this.selectors.title);
      this.actionBarTitle = this.actionBar.querySelector(this.selectors.actionBarTitle);
      this.header = document.querySelector(this.selectors.header);

      if (this.title) {
        this.actionBarTitle.ariaHidden = 'true';
        window.addEventListener('scroll', this.toggleActionBar.bind(this), {passive: true});
        this.toggleActionBar();
        console.log('oyc.JobDetails - initialized');
      }
    }
  },
  toggleActionBar: function () {
    const titleRect = this.title.getBoundingClientRect();
    const headerHeight = this.header ? this.header.scrollHeight : 0;

    if (titleRect.bottom > headerHeight) {
      this.actionBar.classList.add('hide');
      this.actionBarTitle.ariaHidden = 'true';
    } else {
      this.actionBar.classList.remove('hide');
      this.actionBarTitle.ariaHidden = 'false';
    }
  }
};
